import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Image from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';
import {
  Section,
  Content,
  ContentWrapper,
  Description,
  Season,
  Title,
  Button,
  ImageWrapper,
} from './InspirationSection.style';

/**
 * 「クリエーション」トップ画面 > 各シーズンページのサムネイルとリンクボタン
 */
const InspirationSection = ({ copy, content, locale, index }) => {
  const { entry } = content;
  const url = `/${locale}/${entry.contentType === 'editorial' ? 'inspiration' : 'news-and-events'}/${entry.slug}`;

  return (
    <React.Fragment>
      <Section color={content.backgroundColor} index={index} id={content.entryId}>
        <ImageWrapper>
          {entry.image ? (
            <Image src={entry.image} options={{ objectFit: 'contain', size: [560, 860, 480, 600] }} />
          ) : (
            <Placeholder w="100%" pb="70%" />
          )}
        </ImageWrapper>

        <ContentWrapper index={index}>
          <Content>
            <Season>{entry.season || entry.location || <Placeholder w="60%" h="20px" />}</Season>
            <Title>{entry.title || <Placeholder w="100%" h="100px" />}</Title>
            <Description>{entry.description || <Placeholder w="100%" h="75px" />}</Description>
            {content.showLink && (
              <Link href={url} to={url}>
                <Button>{copy.discover}</Button>
              </Link>
            )}
          </Content>
        </ContentWrapper>
      </Section>
    </React.Fragment>
  );
};

InspirationSection.propTypes = {
  copy: PropTypes.shape().isRequired,
  content: PropTypes.shape().isRequired,
  locale: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(InspirationSection);



// WEBPACK FOOTER //
// ./src/pages/InspirationPage/InspirationSection/InspirationSection.js